import React, { Fragment } from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'

import { fetchAdAccountsRequest } from '@store/facebookAds'
import Theme from '@theme'
import { Container, Text } from '@tribegroup'
import LicensingUploadToFacebookAdsManagerButton from './Button'
import UploadToFacebookAdsManagerUploaded from './Uploaded'

interface IUploadToFacebookAdsManagerProps {
  onBeforeUpload?: VoidFunction
  isUploadedToFacebookAds?: boolean
}

export const UploadToFacebookAdsManager: React.FC<IUploadToFacebookAdsManagerProps> = ({
  onBeforeUpload,
  isUploadedToFacebookAds,
}) => {
  const dispatch = useDispatch()

  const onFBAdUpload = () => {
    if (onBeforeUpload) {
      onBeforeUpload()
    }
    dispatch(fetchAdAccountsRequest())
  }

  if (isUploadedToFacebookAds) {
    return (
      <Fragment>
        <UploadToFacebookAdsManagerUploaded />
        <Container onClick={onFBAdUpload} pointer bottomOuterSpacing={0.0625}>
          <Text small color={Theme.primaryColor}>
            &nbsp;
            <FormattedMessage id="socialSubmission.card.modal.facebookAds.accounts.reUpload" />
          </Text>
        </Container>
      </Fragment>
    )
  }

  return (
    <LicensingUploadToFacebookAdsManagerButton onFBAdUpload={onFBAdUpload}>
      <FormattedMessage id="core.text.uploadToFacebookAdsManager" />
    </LicensingUploadToFacebookAdsManagerButton>
  )
}

export default UploadToFacebookAdsManager
